<div class="ac-wrap">
  <mat-form-field>
    <mat-label>{{ 'tositteet.lisaa-tositteita.projekti-kentta.label' | translate | async }}</mat-label>
    <input matInput type="text" [value]="hakuteksti()" (mousedown)="vaihdaTilaKentasta()" (blur)="suljePudotusvalikko()" (input)="paivitaHaku($any($event.target).value)" aria-autocomplete="list" [attr.aria-expanded]="pudotusvalikkoAuki()" [attr.aria-label]="'tositteet.lisaa-tositteita.projekti-kentta.hae-projekti-aria' | translate | async" />
    <mat-icon matSuffix class="chevron" [class.up]="pudotusvalikkoAuki()" (mousedown)="vaihdaTila($event)" aria-hidden="true">expand_more</mat-icon>
  </mat-form-field>

  @if (pudotusvalikkoAuki()) {
    <div class="ac-panel" role="listbox">
      @if (valittuAvain) {
        <div class="ac-option" (mousedown)="tyhjenna()" role="option">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
          <div>
            <div>{{ 'tositteet.lisaa-tositteita.projekti-kentta.poista-valinta' | translate | async }}</div>
          </div>
        </div>
      }

      @if (suodatetutProjektit().length > 0) {
        <div class="ac-section">{{ 'tositteet.lisaa-tositteita.projekti-kentta.projektit-otsikko' | translate | async }}</div>

        @for (p of suodatetutProjektit(); track p.avain) {
          <div class="ac-option" (mousedown)="valitseProjekti(p)" role="option">
            <span class="project-chip" [style.background]="p.taustavari" [style.color]="p.varikoodi">{{ p.nimi }}</span>
          </div>
        }
      }

      @if (suodatetutProjektit().length === 0) {
        <div class="ac-option ei-tuloksia">{{ 'tositteet.lisaa-tositteita.projekti-kentta.ei-tuloksia' | translate | async }}</div>
      }
    </div>
  }
</div>
